import { Button, Flex, Text } from '@/components';
import { ProjectResourceGuard } from '@/features/authentication/_components/ProjectResourceGuard';
import { PublishedProjectMutableGuard } from '@/features/authentication/_components/PublishedProjectMutableGuard';
import { PinpointMarker } from '@/features/comment/components/pinpoint';
import { useProject } from '@/features/project/_hooks/project';
import { useId } from '@/hooks';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useProjectDetailDrawerState } from '../../../_components/ProjectDrawerStateProvider';

export const ProjectOtherNotesInformation: FC = () => {
  const { t } = useTranslation();
  const { id } = useId();
  const project = useProject(id);
  const { setDrawerState } = useProjectDetailDrawerState();

  return (
    <Flex vertical gap={16}>
      <Flex justify="space-between">
        <Text text={t('other-special-notes')} variant="h3" />
        <ProjectResourceGuard onlyEdit>
          <PublishedProjectMutableGuard>
            {!project.data?.isLocked && (
              <Button
                type="primary"
                onClick={() => {
                  setDrawerState({
                    open: true,
                    type: 'other-notes',
                  });
                }}
              >
                {t('edit')}
              </Button>
            )}
          </PublishedProjectMutableGuard>
        </ProjectResourceGuard>
      </Flex>
      <PinpointMarker
        pinpoint={{
          path: { project: id },
          field: 'ss.other-special-notes',
        }}
      >
        <Text
          key="other-special-notes"
          weight="regular"
          variant="body"
          text={project.data?.otherSpecialNotes}
        />
      </PinpointMarker>
    </Flex>
  );
};
